import { openNotification } from "../../../globals/Components/Notification/Notification";
import { serverMessages, serverMessagesNoOpenNotification } from "../../serverMessages";
import { setErrorMessageResponse, setMessageResponse, toggleErrorIndicator, toggleLoadingIndicator } from "../../system/actions";
import { MessageResponse } from "../../system/types";
import { AppThunk } from "../../thunks";
import {GetAllCategorysAPI} from './restCallCategories'
import { setCategories } from './actions';
export const GetAllCategorys = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await GetAllCategorysAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(setCategories(responseData.Response)); 
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};